module.exports = __webpack_public_path__ + "static/media/badge1.24867c52.svg";